module.exports = __webpack_public_path__ + "static/media/giftbox.473138aa.svg";